import React from 'react'
import ProductRow from '../ProductRow'

export default class ProductTable extends React.PureComponent {

    render() {
        const {products, selected, clickHandler, widgetType} = this.props
        const delayPeriod = 100

        return (
            <div className="text-center">
                {
                    products
                    .filter(function(product) {
                        if (product.hidden.includes(widgetType)) {
                            return false;
                        }
          
                        return true;
                    })
                    .map(function (product, key) {
                            return (
                                <ProductRow
                                    key={key}
                                    product={product}
                                    selected={selected}
                                    delay={delayPeriod * key}
                                    clickHandler={clickHandler}
                                />
                            )
                        }
                    )
                }
            </div>
        )
    }
}